import { useState } from 'react';
// import { useLogin } from '../hooks/useLogin'; // Firebase login hook paused
import { useNavigate, Link } from 'react-router-dom';
import { useAuthContext } from '../hooks/useAuthContext';

const Login = () => {
  const [email, setEmail] = useState('admin@sikhera.com'); // Default for easy testing
  const [password, setPassword] = useState('admin123');      // Default for easy testing
  // const { login, error, isLoading } = useLogin(); // Firebase hook paused
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const { dispatch } = useAuthContext();
  const navigate = useNavigate();

  // Local login function for testing
  const localLogin = async (email, password) => {
    setIsLoading(true);
    setError(null);

    // Simulate network delay
    await new Promise(resolve => setTimeout(resolve, 500));

    if (email === 'admin@sikhera.com' && password === 'admin123') {
      const user = { email: 'admin@sikhera.com', role: 'admin' }; // Mock user object
      dispatch({ type: 'LOGIN', payload: user });
      setIsLoading(false);
      navigate('/admin');
    } else {
      setError('Invalid credentials for local admin.');
      setIsLoading(false);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    localLogin(email, password);
  };

  return (
    <div className="flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8 bg-gray-50" style={{ minHeight: '100vh' }}>
      <div className="w-full max-w-md p-8 space-y-6 bg-white rounded-xl shadow-lg">
        <h2 className="text-3xl font-bold text-center text-gray-900">Admin Login</h2>
        <p className="text-center text-sm text-gray-600">Enter test credentials to access the dashboard.</p>
        <form className="space-y-6" onSubmit={handleSubmit}>
          <div>
            <label className="block text-sm font-medium text-gray-700">Email Address</label>
            <input
              type="email"
              onChange={(e) => setEmail(e.target.value)}
              value={email}
              required
              className="w-full px-3 py-2 mt-1 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700">Password</label>
            <input
              type="password"
              onChange={(e) => setPassword(e.target.value)}
              value={password}
              required
              className="w-full px-3 py-2 mt-1 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>
          <div>
            <button
              type="submit"
              disabled={isLoading}
              className="w-full bg-blue-600 text-white font-bold py-3 px-4 rounded-lg hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-colors duration-300 disabled:bg-blue-400"
            >
              {isLoading ? 'Logging in...' : 'Login as Admin'}
            </button>
          </div>
          {error && <p className="text-red-500 text-sm text-center">{error}</p>}
          <div className="text-sm text-center">
            <Link to="/" className="font-medium text-blue-600 hover:text-blue-500">
              &larr; Back to Home
            </Link>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Login;
